import { useEffect, useState } from 'react';
import { Minus, Plus, RotateCcw } from 'lucide-react';
import DropdownMenu from './DropdownMenu';
import { MIN_ZOOM, MAX_ZOOM, WORKSPACE_ZOOMS, getWorkspaceZoom, setWorkspaceZoom, decrementWorkspaceZoom, incrementWorkspaceZoom, resetWorkspaceZoom } from '../lib/displayScale';

export default function WorkspaceZoom(){
  const [percentage,setPercentage]=useState(getWorkspaceZoom);
  useEffect(()=>{
    const changed=event=>setPercentage(event.detail?.percentage??getWorkspaceZoom());
    window.addEventListener('crm-workspace-zoom-change',changed);
    return()=>window.removeEventListener('crm-workspace-zoom-change',changed);
  },[]);
  return <div className="workspace-zoom" role="group" aria-label="Workspace zoom">
    <button type="button" className="workspace-zoom-step" title="Zoom out" aria-label="Zoom out" disabled={percentage<=MIN_ZOOM} onClick={decrementWorkspaceZoom}><Minus size={15}/></button>
    <DropdownMenu ariaLabel={`Reset zoom / current percentage (${percentage}%)`} title={`Reset zoom / current percentage (${percentage}%)`} trigger={<span>{percentage}%</span>} triggerClassName="workspace-zoom-current" menuClassName="workspace-zoom-menu" width={190} groups={[
      {items:[{label:'Reset to 100%',icon:RotateCcw,onSelect:resetWorkspaceZoom}]},
      {label:'Workspace zoom',items:WORKSPACE_ZOOMS.map(value=>({key:String(value),label:`${value}%`,selected:value===percentage,onSelect:()=>setWorkspaceZoom(value)}))}
    ]}/>
    <button type="button" className="workspace-zoom-step" title="Zoom in" aria-label="Zoom in" disabled={percentage>=MAX_ZOOM} onClick={incrementWorkspaceZoom}><Plus size={15}/></button>
  </div>;
}
